import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

export interface MergeSuccessDialogData {
  name: string;
  email: string;
  phone: string;
  provider: string;
}

@Component({
  selector: 'app-merge-success-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './merge-success-dialog.component.html',
  styleUrl: './merge-success-dialog.component.scss',
})
export class MergeSuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MergeSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MergeSuccessDialogData,
  ) {}

  onGoToDashboard(): void {
    this.dialogRef.close(true);
  }
}
